import { Link } from "react-router-dom";
import { Heart } from "lucide-react";

export default function Footer() {
  return (
    <footer
      className="mt-24 border-t"
      style={{ background: "#E7EEFF", borderColor: "#C7B5FF" }}
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid gap-10 md:grid-cols-3">
        <div>
          <h3 className="font-fredoka text-2xl mb-2" style={{ color: "#2D3055" }}>MKBunchBooks<span style={{ color: "#FF6B9D" }}>.com</span></h3>
          <p className="text-sm max-w-xs" style={{ color: "#6B6E88" }}>
            Whimsical children's books by M.K. Bunch — celebrating adventure, discovery, and every child's unrepeatable magic.
          </p>
          <p className="mt-3 font-caveat text-lg" style={{ color: "#FF6B9D" }}>Written with love from Washington, D.C.</p>
          <a href="mailto:hello@mkbunchbooks.com" className="mt-3 inline-flex items-center gap-2 font-fredoka text-sm hover:underline" style={{ color: "#2D3055" }} data-testid="footer-email">
            hello@mkbunchbooks.com
          </a>
        </div>
        <div>
          <h4 className="font-fredoka text-lg mb-3" style={{ color: "#2D3055" }}>Wander</h4>
          <ul className="space-y-2 text-sm" style={{ color: "#2D3055" }}>
            <li><Link to="/books" className="hover:text-[#FF6B9D]" data-testid="footer-books">All Books</Link></li>
            <li><Link to="/about" className="hover:text-[#FF6B9D]" data-testid="footer-about">About the Author</Link></li>
            <li><Link to="/blog" className="hover:text-[#FF6B9D]" data-testid="footer-blog">Blog & Notes</Link></li>
            <li><Link to="/contact" className="hover:text-[#FF6B9D]" data-testid="footer-contact">Say Hello</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-fredoka text-lg mb-3" style={{ color: "#2D3055" }}>A Small Reminder</h4>
          <p className="font-caveat text-2xl leading-tight" style={{ color: "#FF6B9D" }}>
            You are wonderfully, unmistakably you — and that is the whole point.
          </p>
        </div>
      </div>
      <div
        className="border-t px-6 lg:px-10 py-5 flex flex-col md:flex-row items-center justify-between gap-2"
        style={{ borderColor: "#C7B5FF" }}
      >
        <p className="text-xs" style={{ color: "#7E82A1" }}>
          © {new Date().getFullYear()} M.K. Bunch. All stories are quietly loved.
        </p>
        <p className="text-xs inline-flex items-center gap-1" style={{ color: "#7E82A1" }}>
          Made with <Heart size={12} className="inline" style={{ color: "#FF6B9D" }} /> for small readers.
        </p>
      </div>
    </footer>
  );
}
